import { isMobileDevice } from "@hg/recall-frame"
import { useCallback, useEffect, useState } from "react"

import { i18n } from "@/i18n"
import { Modal } from "../Modal"
import { Keyboard } from "./Keyboard"

import styles from "./index.module.scss"

const MAX_LENGTH = 12

interface Props {
    value?: string
    onChange?: (val: string) => void
}

const CodeInput: React.FC<Props> = (props) => {
    const { value = "", onChange } = props

    const isMobile = isMobileDevice()
    const [showKeyboard, setShowKeyboard] = useState(false)
    const [val, setVal] = useState(value)

    useEffect(() => {
        setVal(value)
    }, [value])

    const handleKeyPress = useCallback((key: string) => {
        setVal((v) => (v + key).slice(0, MAX_LENGTH))
    }, [])

    const handleConfirm = useCallback(() => {
        setShowKeyboard(false)
        val && onChange?.(val)
    }, [val, onChange])

    const handleClose = useCallback(() => {
        setShowKeyboard(false)
        setVal(value) // 重置为原始值
    }, [value])

    return (
        <>
            <input
                value={value}
                inputMode="none"
                onChange={(e) =>
                    onChange?.(e.target.value.substring(0, MAX_LENGTH))
                }
                onClick={
                    isMobile
                        ? () => {
                              setVal(value)
                              setShowKeyboard(true)
                          }
                        : undefined
                }
                placeholder={i18n.getRecall("invite.placeholder")}
                className={styles.input}
            />
            <Modal open={showKeyboard} onCancel={handleClose}>
                <Keyboard
                    type="default"
                    value={val}
                    maxLength={MAX_LENGTH}
                    onKeyPress={handleKeyPress}
                    onValueChange={setVal}
                    onClear={() => setVal("")}
                    onConfirm={handleConfirm}
                />
            </Modal>
        </>
    )
}

export default CodeInput
